import { z } from 'zod';

export const chatFileSchema = z.object({
  uploadId: z.string(),
  fileName: z.string(),
  fileType: z.string(),
  fileUrl: z.string(),
});

export const chatMessageSchema = z.object({
  message: z.string().min(1).max(5000),
  threadId: z.string().nullable().optional(),
  files: z.array(chatFileSchema).optional(),
});

export type ChatFileInput = z.infer<typeof chatFileSchema>;
export type ChatMessageInput = z.infer<typeof chatMessageSchema>;
